


  import {defineComponent} from 'vue';

  import ToTop from '@/components/shared/TopButtonComponent.vue';
  import Navigator from '@/components/shared/NavigatorComponent.vue';
  import SubNavigator from '@/components/shared/SubNavigator.vue';
  import TicketListItem from '@/components/ticketList/TicketListItem.vue';
  import paycoUtils from "@/assets/js/utils";
  import NoTicketComponent from "@/components/ticketList/NoTicketComponent.vue";
  import router from "@/router";
  import PageableRequest from "@/domain/request/PageableRequest";
  import api from "@/api/backend-api";
  import * as _ from "lodash";
  import Order from "@/domain/order/Order";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {mapGetters} from "vuex";
  import store from "@/store";

  export default defineComponent({
    name: 'MyOrderView',
    components: {
      HeaderComponent,
      Navigator,
      SubNavigator,
      TicketListItem,
      NoTicketComponent,
      ToTop,
    },
    data() {
      return {
        totalCount: 4,
        page : 1 as number,
        perPage: 20 as number,
        hasMorePage: true as boolean,

        isLoading: false as boolean,
        isFirstLoading: true as boolean,

        debouncedScrollEvent: () => {return},
        orders: [] as Array<Order>,
      }
    },
    mounted() {
      this.loadNewTicket();
      this.debouncedScrollEvent = _.debounce(this.infiniteScrollEvent, 100);
      window.addEventListener('scroll', this.debouncedScrollEvent);
    },
    beforeUnmount(): void {
      window.removeEventListener('scroll', this.debouncedScrollEvent);
    },
    computed: {
      // eslint-disable-next-line
      orderGroupedByDate(): Map<string, Array<any>> { //todo any to class
        return paycoUtils.groupBy(this.orders, "orderCompleteYmd");
      },
      isEmpty(): boolean {
        return this.totalCount === 0;
      },
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    methods: {
      moveToDetailPage(orderId: number): void {
        router.push(new NamedRouting('OrderDetailView', {orderId: orderId}));
      },
      infiniteScrollEvent(): void {
        const targetElement = document.getElementById("app");
        if (targetElement === undefined) {
          return;
        }

        const heightOfElement: number = targetElement!.scrollHeight;
        const topOfElement: number = window.scrollY;
        const clientHeightOfElement: number = targetElement!.clientHeight;
        const bottomOffset = 100;

        if (heightOfElement <= topOfElement + clientHeightOfElement + bottomOffset) {
          this.loadMoreTicket();
        }
      },
      loadNewTicket(): void {
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page = 1;
        this.hasMorePage = true;
        const request = new PageableRequest(this.page, this.perPage);

        api.getOrderList(request).then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('MyOrderView'));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          this.totalCount = response.data.result.totalCount;
          this.orders = response.data.result.list.map(order => new Order(order));

          if (response.data.result.list.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isFirstLoading = false;
          this.isLoading = false;
        });
      },
      loadMoreTicket(): void {
        if (!this.hasMorePage || this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page += 1;
        const request = new PageableRequest(this.page, this.perPage);

        api.getOrderList(request).then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('MyOrderView'));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          this.totalCount = response.data.result.totalCount;
          response.data.result.list.forEach(order => this.orders.push(new Order(order)));

          if (response.data.result.list.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
    }
  })
